import Image from 'next/image';
import Link from 'next/link';

import waiting from '@/assets/waiting.svg';
import EventListItem, {
  EventListItemProps,
} from '@/components/Event/EventListItem';
import useViewport from '@/hooks/useViewport';

export type EventListProps = {
  events: EventListItemProps[];
};

const MobileEventList = (props: EventListProps) => {
  const { events } = props;

  if (events.length > 0) {
    return (
      <div className={`flex flex-col gap-[24px]`}>
        <p className={`text-h3 font-bold text-gray-500`}>Upcoming Shows</p>
        {events.map((event) => (
          <Link href={`/events/${event.id}`} key={event.id}>
            <a>
              <EventListItem {...event}></EventListItem>
            </a>
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center`}>
      <div className={`p-[4px]`}>
        <Image
          width={140}
          height={140}
          src={waiting}
          alt="waiting"
          className={`m-[4px] object-cover`}
        />
      </div>
      <p className={`p-[10px] text-center text-h4 font-medium text-gray-300`}>
        No upcoming shows, <br /> check back soon
      </p>
    </div>
  );
};

const DesktopEventList = (props: EventListProps) => {
  const { events } = props;

  if (events.length > 0) {
    return (
      <div className={`flex flex-col gap-[40px] pt-[25px]`}>
        <p className={`text-h1 font-bold text-gray-500`}>Upcoming Shows</p>
        {events.map((event) => (
          <Link href={`/events/${event.id}`} key={event.id}>
            <a>
              <EventListItem {...event}></EventListItem>
            </a>
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center pt-[57px]`}>
      <div className={`p-[4px]`}>
        <Image
          width={140}
          height={140}
          src={waiting}
          alt="waiting"
          className={`object-cover`}
        />
      </div>
      <p className={`p-[10px] text-center text-h4 font-medium text-gray-300`}>
        No upcoming shows, <br /> check back soon
      </p>
    </div>
  );
};

const EventList = (props: EventListProps) => {
  const {} = props;
  const viewport = useViewport();

  if (viewport == `mobile` || viewport == `tablet`) {
    return <MobileEventList {...props} />;
  }
  if (viewport == `desktop`) {
    return <DesktopEventList {...props} />;
  }

  return null;
};

export default EventList;
